import React from "react";
import "./SiteflowPageStyle.css";

export default class SiteflowPageComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {};
    }
    
    render(){
        return(
            <div>
                Siteflow Settings Tab
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/admin/components/Main/SettingsPage/Siteflow/SiteflowPage.js